import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { LogoutAction } from '../../actions/logout/logout-action';
import { LogoutSuccessAction } from '../../actions/logout/logout-success-action';
import { LogoutErrorAction } from '../../actions/logout/logout-error-action';

@Injectable()
export class LogoutEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public Logout = createEffect(() => this.actions
    .pipe(
      ofType(LogoutAction.type),
      mergeMap(() => {
        return this.api.logout().then(() => {
          return new LogoutSuccessAction();
        }, error => {
          return new LogoutErrorAction(error);
        });
      })
    ));
}
